import { Reveal } from "./Reveal";

const CHAPTERS = [
  {
    n: "01",
    title: "The Root",
    heading: "Kanak — the old word for gold",
    body: "Every kanakleaf piece begins with the Sanskrit root kanak: gold, as it was spoken of for a thousand years. We work in sterling silver and warm gold finishes, honouring that lineage with jewellery made to be lived in, not locked away.",
    image: "https://images.unsplash.com/photo-1620656798579-1984d9e87df7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxlbGVnYW50JTIwd29tYW4lMjB3ZWFyaW5nJTIwZ29sZCUyMG5lY2tsYWNlfGVufDB8fHx8MTc4NjA3ODkzNHww&ixlib=rb-4.1.0&q=85",
    alt: "Woman wearing a prominent gold necklace",
    flip: false,
  },
  {
    n: "02",
    title: "The Leaf",
    heading: "Botany, pressed in metal",
    body: "Ferns, wreaths and unfurling leaves are sketched from real cuttings, then cast into bands, bracelets and studs. Each motif keeps the irregularity of the plant it came from — no two veins exactly alike.",
    image: "https://images.unsplash.com/photo-1655255114527-d0a834d9a774?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHxtaW5pbWFsaXN0JTIwamV3ZWxyeSUyMGVkaXRvcmlhbHxlbnwwfHx8fDE3ODYwNzg5NDd8MA&ixlib=rb-4.1.0&q=85",
    alt: "Editorial shot of a gold bracelet",
    flip: true,
  },
  {
    n: "03",
    title: "The Stone",
    heading: "A signature in violet",
    body: "Amethyst and violet zircon run through the collection like a watermark — a quiet flash of purple against gold. It is the colour of dusk in the garden, and it is unmistakably ours.",
    image: "https://images.unsplash.com/photo-1611591437281-460bfbe1220a?auto=format&fit=crop&w=1200&q=80",
    alt: "Close-up of a gemstone ring",
    flip: false,
  },
];

const Chapter = ({ c }) => (
  <div
    className="grid grid-cols-1 items-center gap-12 py-16 md:py-24 lg:grid-cols-12"
    data-testid={`manifesto-chapter-${c.n}`}
  >
    <Reveal className={`lg:col-span-5 ${c.flip ? "lg:order-2 lg:col-start-8" : "lg:col-start-1"}`}>
      <div className="relative">
        <span className="absolute -top-10 -left-2 font-serif text-[7rem] italic leading-none text-gold/25 select-none" aria-hidden="true">
          {c.n}
        </span>
        <div className="relative aspect-[4/5] overflow-hidden rounded-2xl bg-sand">
          <img
            src={c.image}
            alt={c.alt}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-700 ease-out hover:scale-105"
          />
        </div>
      </div>
    </Reveal>
    <div className={`lg:col-span-5 ${c.flip ? "lg:order-1 lg:col-start-2" : "lg:col-start-7"}`}>
      <Reveal delay={0.1}>
        <p className="mb-3 text-xs uppercase tracking-[0.35em] text-golddark">
          Chapter {c.n} — {c.title}
        </p>
      </Reveal>
      <Reveal delay={0.2}>
        <h3 className="mb-6 font-serif text-3xl leading-snug tracking-tight text-ink md:text-4xl">
          {c.heading}
        </h3>
      </Reveal>
      <Reveal delay={0.3}>
        <p className="max-w-md text-base leading-relaxed text-smoke">{c.body}</p>
      </Reveal>
    </div>
  </div>
);

export const Manifesto = () => (
  <section id="manifesto" className="border-t border-borderline bg-sand/60 py-14 md:py-20" data-testid="manifesto-section">
    <div className="mx-auto max-w-7xl px-6 md:px-10">
      <Reveal>
        <p className="text-xs uppercase tracking-[0.35em] text-golddark">The manifesto</p>
        <h2 className="mt-4 max-w-2xl font-serif text-4xl leading-tight tracking-tight text-ink md:text-5xl">
          Three things we <em className="italic text-golddark">believe</em>
      </h2>
      </Reveal>
      {CHAPTERS.map((c) => (
        <Chapter key={c.n} c={c} />
      ))}
    </div>
  </section>
);
